import React, { useState } from "react";
import { Box, Dialog, useMediaQuery, useTheme, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";


import Mapa from "../../assets/images/mapa.png";
import PinClientes from "../../assets/images/pinClientes.svg";
import PinEMA from "../../assets/images/pinEMA.svg";
import MapCard from "../mapCard";

const locations = [
  {
    country: "Puerto Rico",
    xMapa: "500%",
    yMapa: "-265%",
    yMapaTrans: "-285%",
    xMapaMobile: "275%",
    yMapaMobile: "-200%",
    yMapaTransMobile: "-220%",
    xNombre: "95%",
    yNombre: "-175%",
    type: "cliente",
    contactos: [
      {
        compania: "PRO ENERGY",
        nombre: "Carlos R. Nieves Rodríguez",
        telefono: "+1 787 707 0008",
        mail: "c.nieves@pro-energycorp.com",
      },
      {
        compania: "PRO ENERGY",
        nombre: "Jennifer Martinez",
        telefono: "+1 787 707 0008",
        mail: "j.martinez@pro-energycorp.com",
      },
    ],
  },
  {
    country: "Costa Rica",
    xMapa: "20%",
    yMapa: "-90%",
    yMapaTrans: "-110%",
    xMapaMobile: "-40%",
    yMapaMobile: "-120%",
    yMapaTransMobile: "-140%",
    xNombre: "-110%",
    yNombre: "-55%",
    type: "cliente",
    contactos: [
      {
        compania: "ELVATRON",
        nombre: "Andre Sonderegger Beyeler",
        telefono: "+506 8341 6687",
        mail: "andre.sonderegger@elvatron.com",
      },
    ],  
  },
  {
    country: "Colombia",
    xMapa: "400%",
    yMapa: "50%",
    yMapaTrans: "30%",
    xMapaMobile: "225%",
    yMapaMobile: "5%",
    yMapaTransMobile: "-15%",
    xNombre: "-50%",
    yNombre: "5%",
    type: "cliente",
    contactos: [
      {
        compania: "MELEC",
        nombre: "Fernando Bernal",
        telefono: "+57 3108060034",
        mail: "becomarsas@gmail.com",
      },
    ],
  },
  {
    country: "Ecuador",
    xMapa: "250%",
    yMapa: "130%",
    yMapaTrans: "110%",
    xMapaMobile: "130%",
    yMapaMobile: "40%",
    yMapaTransMobile: "20%",
    xNombre: "-55%",
    yNombre: "65%",
    type: "cliente",
    contactos: [
      {
        compania: "J R ELECTRIC SUPPLY",
        nombre: "Arevalo Roosvelt",
        telefono: "+593 99 990 9317",
        mail: "rarevalo@jrelectric.com.ec",
      },
    ],
  },
  {
    country: "Perú",
    xMapa: "350%",
    yMapa: "300%",
    yMapaTrans: "280%",
    xMapaMobile: "195%",
    yMapaMobile: "140%",
    yMapaTransMobile: "120%",
    xNombre: "5%",
    yNombre: "160%",
    type: "cliente",
    contactos: [
      {
        compania: "TRANSWORLD",
        nombre: "Jorge De Geyter",
        telefono: "+56 9 8502 2511",
        mail: "jdegeyter@transworld.cl",
      },
      {
        compania: "TRANSWORLD",
        nombre: "Luciano Fernandez Figari",
        telefono: "+56 9 8360 2233",
        mail: "ljfernandez@transworld.cl",
      },
    ],
  },
  {
    country: "Brasil",
    xMapa: "1050%",
    yMapa: "300%",
    yMapaTrans: "280%",
    xMapaMobile: "655%",
    yMapaMobile: "170%",
    yMapaTransMobile: "150%",
    xNombre: "365%",
    yNombre: "160%",
    type: "cliente",
    contactos: [ 
      {
        compania: "MORANDO",
        nombre: "Guillermo Morando",
        telefono: "+55 41 9987 5500",
        mail: "gui.morando@outlook.com",
      },
    ],
  },
  {
    country: "Bolivia",
    xMapa: "650%",
    yMapa: "400%",
    yMapaTrans: "380%",
    xMapaMobile: "355%",
    yMapaMobile: "200%",
    yMapaTransMobile: "28%",
    xNombre: "20%",
    yNombre: "230%",
    type: "cliente",
    contactos: [
      {
        compania: "YARTECH",
        nombre: "Federico Macri",
        telefono: "+598 96 211 411",
        mail: "fmacri@yartech.com.uy",
      },
    ],
  },
  {
    country: "Paraguay",
    xMapa: "850%",
    yMapa: "510%",
    yMapaTrans: "490%",
    xMapaMobile: "475%",
    yMapaMobile: "270%",
    yMapaTransMobile: "250%",
    xNombre: "180%",
    yNombre: "280%",
    type: "cliente",
    contactos: [
      {
        compania: "MORANDO",
        nombre: "Guillermo Morando",
        telefono: "+55 41 9987 5500",
        mail: "gui.morando@outlook.com",
      },
      {
        compania: "AESA",
        nombre: "Guillermo Morando",
        telefono: "+595 981 822539",
        mail: "andres.gomez@aesa.com.py",
      },
    ],
  },
  {
    country: "Chile",
    xMapa: "470%",
    yMapa: "600%",
    yMapaTrans: "580%",
    xMapaMobile: "260%",
    yMapaMobile: "400%",
    yMapaTransMobile: "380%",
    xNombre: "50%",
    yNombre: "330%",
    type: "cliente",
    contactos: [
      {
        compania: "TRANSWORLD",
        nombre: "Jorge De Geyter",
        telefono: "+56 9 8502 2511",
        mail: "jdegeyter@transworld.cl",
      },
      {
        compania: "TRANSWORLD",
        nombre: "Luciano Fernandez Figari",
        telefono: "+56 9 8360 2233",
        mail: "ljfernandez@transworld.cl",
      },
    ],
  },
  {
    country: "Uruguay",
    xMapa: "900%",
    yMapa: "700%",
    yMapaTrans: "680%",
    xMapaMobile: "525%",
    yMapaMobile: "380%",
    yMapaTransMobile: "360%",
    xNombre: "210%",
    yNombre: "400%",
    type: "cliente",
    contactos: [
      {
        compania: "YARTECH",
        nombre: "Federico Macri",
        telefono: "+598 96 211 411",
        mail: "fmacri@yartech.com.uy",
      },
    ],
  },
  {
    country: "Argentina",
    xMapa: "780%",
    yMapa: "750%",
    yMapaTrans: "730%",
    xMapaMobile: "400%",
    yMapaMobile: "425%",
    yMapaTransMobile: "405%",
    xNombre: "30%",
    yNombre: "430%",
    type: "ema",
    contactos: [
      {
        compania: "Ema Electromecanica S.A.",
        nombre: "Pilar Carmona",
        telefono: "+54 9 11 7240-4680",
        mail: "pcarmona@ema.com.ar",
      },
    ],
  },
];

const MapPin = ({ xMapa, yMapa, yMapaTrans, type, isActive, onClick }) => {
  const icon = type === "cliente" ? PinClientes : PinEMA;

  return (
    <Box
      component="button"
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        zIndex: 2,
        transition: "transform 0.2s ease-in-out",
        cursor: "pointer",
        background: "none",
        border: "none",
        padding: 0,
        outline: "none",
        transform: `${isActive
            ? `translate(${xMapa}, ${yMapaTrans}) scale(1.5)`
            : `translate(${xMapa}, ${yMapa})`
          } `,
        "&:hover": {
          transform: `translate(${xMapa}, ${yMapaTrans}) scale(1.5)`,
        },
      }}
    >
      <img src={icon} alt="Pin" style={{ width: "auto", height: "auto" }} />
    </Box>
  );
};

const MapaObj = () => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClose = () => setSelectedLocation(null);

  return (
    <Box sx={{ position: "relative", width: "auto" }}>
      <img
        src={Mapa}
        alt="Mapa"
        style={{ width: "100%", height: "auto", display: "block" }}
      />

      {/* 🔹 Render de pines */}
      {locations.map((location) => (
        <MapPin
          key={location.country}
          xMapa={isMobile && location.xMapaMobile ? location.xMapaMobile : location.xMapa}
          yMapa={isMobile && location.yMapaMobile ? location.yMapaMobile : location.yMapa}
          yMapaTrans={isMobile && location.yMapaTransMobile ? location.yMapaTransMobile : location.yMapaTrans}
          type={location.type}
          isActive={selectedLocation?.country === location.country}
          onClick={() =>
            setSelectedLocation(
              selectedLocation?.country === location.country ? null : location
            )
          }
        />
      ))}

      {/* 🔹 Desktop: muestra el panel lateral flotante */}
      {!isMobile && selectedLocation && (
        <Box
          sx={{
            position: "absolute",
            top: "60%",
            left: "125%",
            zIndex: 10,
            width: "38rem",
          }}
        >
          <Swiper
            modules={[Navigation, Pagination]}
            navigation
            pagination={{ clickable: true }}
            spaceBetween={16}
            slidesPerView={1}
          >
            {selectedLocation.contactos.map((c, i) => (
              <SwiperSlide key={i}>
                <MapCard
                  pais={selectedLocation.country}
                  compania={c.compania}
                  nombre={c.nombre}
                  telefono={c.telefono}
                  mail={c.mail}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      )}

      {/* 🔹 Mobile: abre un popup */}
      {isMobile && (
        <Dialog
          open={Boolean(selectedLocation)}
          onClose={handleClose}
          fullWidth
          maxWidth="sm"
          PaperProps={{
            sx: {
              borderRadius: "1.5rem",
              backgroundColor: "#fff",
              p: 2,
            },
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", right: 10, top: 10, color: "#1B2466" }}
          >
            <CloseIcon />
          </IconButton>

          {selectedLocation && (
            <Box sx={{ mt: 4, mb: 2 }}>
              <Swiper
                modules={[Pagination]}
                pagination={{ clickable: true }}
                spaceBetween={16}
                slidesPerView={1}
              >
                {selectedLocation.contactos.map((c, i) => (
                  <SwiperSlide key={i}>
                    <MapCard
                      pais={selectedLocation.country}
                      compania={c.compania}
                      nombre={c.nombre}
                      telefono={c.telefono}
                      mail={c.mail}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </Box>
          )}
        </Dialog>
      )}
    </Box>
  );
};

export default MapaObj;